import { Component } from "react";
import config from "../utils/siteConfig";
import { Link, navigate } from "gatsby";
import intl from "../services/intl";

export function magicUrl(nodeOrUrl) {
  let formats = {
    ContentfulArticle: (n) => `/${config.contentHubArticlesUrl}/${n.slug}`,
    ContentfulProduct: (n) => `/products/${n.slug}`,
    ContentfulIngredient: (n) => `/ingredients/${n.slug}`,
  };
  let hasFormat =
    nodeOrUrl &&
    typeof nodeOrUrl === "object" &&
    nodeOrUrl.__typename &&
    formats.hasOwnProperty(nodeOrUrl.__typename);

  const url = hasFormat
    ? formats[nodeOrUrl.__typename](nodeOrUrl)
    : typeof nodeOrUrl === "object" &&
        nodeOrUrl !== null &&
        typeof nodeOrUrl.slug === "string"
      ? formats.ContentfulArticle(nodeOrUrl)
      : nodeOrUrl;
  return intl.localizePath(url);
}

export function magicNavigate(node, link = false, target = "_blank") {
  return (e) => {
    e.stopPropagation();
    if (link) {
      window.open(link, target);
    } else {
      navigate(magicUrl(node));
    }
  };
}

export default class MagicLink extends Component {
  render() {
    let {
      to,
      state,
      href,
      children,
      className,
      target,
      title,
      onClick,
      onMouseOver,
      ariaLabel,
      rel,
      hrefLang = "x-default",
      draggable,
      id,
      ...options
    } = this.props;

    const linkHref =
      href ?? (to != null && to !== "" ? magicUrl(to) : undefined);

    return (
      <a
        className={className}
        title={title}
        href={linkHref}
        hrefLang={hrefLang}
        aria-label={ariaLabel}
        rel={rel}
        id={id}
        draggable={draggable}
      >
        {children}
      </a>
    );
  }
}
